import { ActionType, TState, PaymentType } from '../types';

export interface TSetSelectedPaymentTypeAction {
  type: ActionType.SET_SELECTED_PAYMENT_TYPE;
  paymentType: PaymentType;
}

export const setSelectedPaymentType = (
  state: TState,
  action: TSetSelectedPaymentTypeAction,
): TState => ({
  ...state,
  selectedPaymentType: action.paymentType,
});
